import { FACTIONS } from '../../shared/factions';
import type { FactionId } from '../../shared/types';
export interface ATOverlayScene { add: { container: (x: number, y: number) => ATContainer; rectangle: (x: number, y: number, w: number, h: number, color: number, alpha?: number) => ATRect; text: (x: number, y: number, text: string, style: object) => ATText; graphics: () => ATGraphics; }; time: { delayedCall: (delay: number, cb: () => void) => ATTimerEvent; }; }
export interface ATContainer { add: (items: unknown | unknown[]) => void; setDepth: (depth: number) => this; destroy: () => void; }
export interface ATRect { setInteractive: (opts?: object) => this; on: (event: string, cb: () => void) => void; setStrokeStyle?: (width: number, color: number) => this; }
export interface ATText { setOrigin: (x: number, y?: number) => this; }
export interface ATGraphics { fillStyle: (color: number, alpha: number) => void; fillTriangle: (x1: number, y1: number, x2: number, y2: number, x3: number, y3: number) => void; lineStyle?: (width: number, color: number, alpha: number) => void; }
export interface ATTimerEvent { remove: () => void; }
export const AFFINITY_TUTORIAL_DURATION_MS = 5000;
const CANVAS_W = 800;
const CANVAS_H = 600;
/**
 * 🧒 小明 2026-05-21 01:12 leftover fix: copy now uses the canonical faction
 * emoji + name from src/shared/factions.ts (single source of truth) and drops
 * the "1.5 倍" jargon in favour of "傷害多很多!" for a 9-year-old reader.
 *
 * The old "黃色星算"-style labels confused kids ("the in-game pause menu only
 * says 星算門, but here a colour prefix suddenly appears"). We keep
 * `FACTION_DISPLAY_NAMES` exported but populate it with the new "⚡星算門"
 * format so any consumer that still imports the map gets the corrected copy
 * for free.
 */
export const FACTION_DISPLAY_NAMES: Record<string, string> = {
  celestial: `${FACTIONS.celestial.emoji}${FACTIONS.celestial.displayName}`,
  runic:     `${FACTIONS.runic.emoji}${FACTIONS.runic.displayName}`,
  techno:    `${FACTIONS.techno.emoji}${FACTIONS.techno.displayName}`,
  elemental: `${FACTIONS.elemental.emoji}${FACTIONS.elemental.displayName}`,
  dominion:  `${FACTIONS.dominion.emoji}${FACTIONS.dominion.displayName}`,
};
export function showAffinityTutorial(scene: ATOverlayScene, factionName: string, enemyX: number, enemyY: number, onDismiss?: () => void): ATContainer {
  const faction = FACTIONS[factionName as FactionId];
  const label = faction ? `${faction.emoji}${faction.displayName}` : (FACTION_DISPLAY_NAMES[factionName] ?? factionName);
  const tipText = `💡 用 ${label} 技能打它，傷害多很多！`;
  const container = scene.add.container(0, 0).setDepth(210);
  const bg = scene.add.rectangle(CANVAS_W / 2, CANVAS_H / 2, CANVAS_W, CANVAS_H, 0x000000, 0.45);
  bg.setInteractive(); container.add(bg);
  const arrowX = Math.max(30, Math.min(CANVAS_W - 30, enemyX));
  const arrowTipY = Math.max(50, Math.min(CANVAS_H - 20, enemyY - 20));
  const arrow = scene.add.graphics();
  arrow.fillStyle(0xffd54f, 1);
  arrow.fillTriangle(arrowX, arrowTipY, arrowX - 15, arrowTipY - 30, arrowX + 15, arrowTipY - 30);
  container.add(arrow);
  const dialogY = 90;
  const dialogBg = scene.add.rectangle(CANVAS_W / 2, dialogY, 620, 68, 0x000000, 0.85);
  if (dialogBg.setStrokeStyle) dialogBg.setStrokeStyle(2, 0xffd54f);
  container.add(dialogBg);
  const text = scene.add.text(CANVAS_W / 2, dialogY, tipText, { fontSize: '20px', color: '#ffffff', fontFamily: 'sans-serif', align: 'center', wordWrap: { width: 600 } }).setOrigin(0.5);
  container.add(text);
  const hint = scene.add.text(CANVAS_W / 2, dialogY + 36, '（點擊任意處關閉）', { fontSize: '13px', color: '#aaaaaa', fontFamily: 'sans-serif' }).setOrigin(0.5);
  container.add(hint);
  let dismissed = false;
  const dismiss = () => { if (dismissed) return; dismissed = true; timer.remove(); container.destroy(); if (onDismiss) onDismiss(); };
  bg.on('pointerup', dismiss);
  const timer = scene.time.delayedCall(AFFINITY_TUTORIAL_DURATION_MS, dismiss);
  return container;
}
